import { CircleHelp } from "lucide-react";

type ExtraItemProps = {
  title: string;
  fee: string;
  tooltip?: string;
  description?: string;
  icon: JSX.Element;
};

export function ExtraItem({
  title,
  fee,
  tooltip,
  description,
  icon,
}: ExtraItemProps) {
  return (
    <div className="flex items-start gap-3">
      {/* Icon */}
      <span className="mt-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-blue-f0 text-blue-00">
        {icon}
      </span>

      {/* Content */}
      <div className="text-sm leading-relaxed text-dark-6b">
        <div className="inline-flex items-center gap-1.5">
          <strong className="font-bold text-black-31">{title}</strong>

          {tooltip && (
            <div className="group relative">
              <button
                type="button"
                aria-label={`What is ${title}?`}
                className="
                  flex size-4 items-center justify-center
                  rounded-full border border-grey-eb
                  bg-white-f9 text-grey-8b
                  transition-all duration-200
                  hover:border-blue-00
                  hover:bg-blue-00
                  hover:text-white
                "
              >
                <CircleHelp className="h-4 w-4" />
              </button>

              {/* Tooltip */}
              <div
                className="
                  pointer-events-none absolute bottom-[calc(100%+12px)]
                  left-1/2 z-50 hidden w-64
                  -translate-x-1/2
                  rounded-2xl border border-white/30
                  bg-blue-02 p-4
                  text-[0.78rem] leading-relaxed text-white
                  shadow-2xl backdrop-blur-md
                  group-hover:block cursor-help
                "
              >
                {tooltip}

                {/* Arrow */}
                <div
                  className="
                    absolute left-1/2 top-full
                    h-3 w-3 -translate-x-1/2
                    rotate-45 bg-blue-02
                  "
                />
              </div>
            </div>
          )}
        </div>

        {description && <span className="ml-1">{description}</span>}

        <span className="ml-1">: {fee}</span>
      </div>
    </div>
  );
}
